import axios from "axios";
import { toast } from 'react-toastify';
import HelperService from "./HelperService";

interface PropData {
    action: string;
    body?: any;
    isFormData?: boolean;
    isShowError?: boolean;
    id?: string;
    type?: string;
    file?: any;
    key?: any;
    signal?: AbortSignal;
    is_session?: boolean;
    responseType?: string;
}

const WebService = {

    postAPI: function <T>(props: PropData) {
        this.addLoader(props?.id);
        let url = this.getBaseUrl(props.type)
        return new Promise<T>((resolve, reject) => {
            var bodyFormData = new URLSearchParams();
            for (let key in props.body) {
                bodyFormData.append(key, props.body[key]);
            }
            axios
                .post(
                    `${url}${props.action}`,
                    props.isFormData ? bodyFormData : props.body,
                    {
                        headers: this.getHeaders(props.is_session),
                    }
                )
                .then((response) => {
                    resolve(response.data);
                    this.removeLoader(props?.id);
                })
                .catch((error) => {
                    if (error && error.response && error.response.status == 401) {
                        this.clearLocalStorage()
                        window.location.href = "/";
                    }
                    this.removeLoader(props?.id);
                    reject(this.errorHandler(error, props.isShowError));
                });
        });
    },

    putAPI: function (props: PropData) {

        this.addLoader(props?.id);
        let url = this.getBaseUrl(props.type)
        return new Promise((resolve, reject) => {
            var bodyFormData = new URLSearchParams();
            for (let key in props.body) {
                bodyFormData.append(key, props.body[key]);
            }
            axios
                .put(`${url}${props.action}`, props.body, {
                    headers: this.getHeaders(props.is_session),
                })
                .then((response) => {
                    resolve(response.data);
                    this.removeLoader(props?.id);
                })
                .catch((error) => {
                    if (error && error.response && error.response.status == 401) {
                        this.clearLocalStorage()
                        window.location.href = "/";
                    }
                    this.removeLoader(props?.id);
                    reject(this.errorHandler(error));
                });
        });
    },

    getAPI: function <T>(props: PropData) {
        var ad: any = {
            headers: this.getHeaders(props.is_session),
        };
        if (props.signal) {
            ad = {
                headers: this.getHeaders(props.is_session),
                signal: props.signal
            }
        }
        if (props.responseType) {
            ad = {
                headers: this.getHeaders(props.is_session),
                signal: props.signal,
                responseType: props.responseType
            }
        }
        this.addLoader(props?.id)
        let url = this.getBaseUrl(props.type)
        return new Promise<T>((resolve, reject) => {
            axios
                .get(`${url}${props.action}`, ad)
                .then((response) => {
                    resolve(response.data);
                    this.removeLoader(props?.id)
                })
                .catch((error) => {
                    if (error && error.response && error.response.status == 401) {
                        this.clearLocalStorage()
                        window.location.href = "/";
                    }
                    this.removeLoader(props?.id)
                    reject(this.errorHandler(error));
                });
        });
    },

    deleteAPI: function (props: PropData) {
        this.addLoader(props?.id)
        let url = this.getBaseUrl(props.type)
        return new Promise((resolve, reject) => {
            axios
                .delete(`${url}${props.action}`, {
                    headers: this.getHeaders(props.is_session),
                })
                .then((response) => {
                    resolve(response.data);
                    this.removeLoader(props?.id)
                })
                .catch((error) => {
                    if (error && error.response && error.response.status == 401) {
                        this.clearLocalStorage()
                        window.location.href = "/";
                    }
                    this.removeLoader(props?.id)
                    reject(this.errorHandler(error));
                });
        });
    },

    fileUploadAPI: function (props: PropData) {
        var formData = new FormData();
        if (!props.key) {
            props.key = "file";
        }
        formData.append(props.key, props.file);
        for (let key in props.body) {
            formData.append(key, props.body[key]);
        }
        this.addLoader(props?.id);
        let url = this.getBaseUrl();
        return new Promise((resolve, reject) => {
            axios
                .post(`${url}${props.action}`, formData, {
                    headers: this.getMultipartHeaders(props.is_session),
                })
                .then((response) => {
                    resolve(response.data);
                    this.removeLoader(props?.id);
                })
                .catch((error) => {
                    // props.isShowError ? reject(this.errorHandler(error)) : reject(error);
                    this.errorHandler(error);
                    this.removeLoader(props?.id);
                });
        });
    },

    getHeaders: function (type?: boolean) {
        if (typeof window !== 'undefined') {
            let session_id = this.getSessionId(type);
            return {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "session_id": session_id
            };
        }
    },

    getMultipartHeaders: function (type?: boolean) {
        if (typeof window !== 'undefined') {
            let session_id = this.getSessionId(type);
            return {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "session_id": session_id
            };
        }
    },

    errorHandler: function (error: any, showErrorOnPopup?: boolean) {
        if (error?.response) {
            error = error.response;
        }
        var errorMessage;
        if (!error || !error.status) {
            errorMessage = "Server Not Responding";
        } else if (error.status === 401) {
            this.clearLocalStorage();
            document.cookie.split(';').forEach(function (c) {
                document.cookie = c.trim().split('=')[0] + '=;' + 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
            });
            setTimeout(() => {
                // window.location.href = "/";
            }, 100)
        } else if (error.status === 500) {
            errorMessage =
                (error &&
                    error.data &&
                    error.data.ErrorDetails &&
                    error.data.ErrorDetails.message) ||
                "An unkown exception has occured. Please contact to administrator";
        } else {
            errorMessage = error.data.message;
        }
        if (!showErrorOnPopup) {
            toast.error(errorMessage);
        }
        return errorMessage;
    },

    addLoader(id: any) {
        if (id) {
            var button = document.getElementById(id) as HTMLButtonElement | null;
            if (button != null) {
                button.disabled = true;
                // button.classList.add("d-flex");
                // button.classList.add("justify-content-center");
                // button.classList.add("align-items-center");
                var loader = document.createElement("img");
                loader.src = "assets/images/loader.gif";
                loader.className = "button-loader";
                const spinner = document.createElement("div");
                spinner.className = "spinner-border";
                spinner.setAttribute("role", "status");
                spinner.style.width = "1.5rem";
                spinner.style.height = "1.5rem";
                spinner.style.marginRight = "5px";
                button.prepend(spinner);
            }
        }
    },

    removeLoader(id: any) {
        if (id) {
            var button = document.getElementById(id) as HTMLButtonElement | null;
            if (button != null) {
                button.disabled = false;
                button.removeChild(button.childNodes[0]);
            }
        }
    },

    clearLocalStorage() {
        if (typeof window !== 'undefined') {
            localStorage.clear()
        }
    },

    getSessionId(type?: boolean) {
        if (typeof window !== 'undefined') {
            let session_id;
            while (!session_id) {
                let num = HelperService.generateOTP(6);
                const sum = num.split('').reduce((acc, digit) => acc + parseInt(digit), 0);
                if (type) {
                    if (sum % 2 === 0) {
                        session_id = num;
                    }
                } else {
                    if (sum % 2 !== 0) {
                        session_id = num;
                    }
                }
            }
            return session_id;
        }
    },

    getBaseUrl(type?: string) {
        if (window.location.hostname === "plotadmin.winayak.com") {
            return "https://plotapi.winayak.com/";
        } else if (window.location.hostname === "devplotadmin.winayak.com") {
            return "https://devplotapi.winayak.com/"
        } else {
            return "http://127.0.0.1:3030/";
        }
    }
};

export default WebService;
